/* eslint-disable @typescript-eslint/no-explicit-any */
export type Validator = (value?: any) => any;

export function composeValidators(...validators: Validator[]) {
  return (value: any) => validators.reduce((error, validator) => error || validator(value), undefined);
}
